module.exports = __webpack_public_path__ + "static/FilmDrop-LogoRiff-5938db3d088c697a35b13763dc84149e.jpg";